import { AppTeamUtil } from '../../core/app-team-util';

export class DeletedAlbum
{
    Id!: number;
    Name!: string;
    ParentId?: number;
    ParentName?: string;
    DeletedOn!: Date;

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
            this.DeletedOn = AppTeamUtil.convertApiDateStringToDate(json['DeletedOn'])!;
        }
    }
}
